var React = require('react');

function Download (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M7.7 11.992a.692.692 0 0 1-.259-.047.718.718 0 0 1-.236-.165L3.647 8.222a.652.652 0 0 1-.2-.506.735.735 0 0 1 .224-.507.691.691 0 0 1 .507-.212c.196 0 .365.07.506.212l2.31 2.333V1.507A.687.687 0 0 1 7.7.8a.687.687 0 0 1 .707.707v8.035l2.333-2.333a.692.692 0 0 1 .506-.212c.197 0 .365.07.507.212.141.141.212.31.212.507 0 .196-.07.365-.212.506L8.195 11.78a.718.718 0 0 1-.236.165.692.692 0 0 1-.259.047zM1.574 15.88c-.377 0-.707-.141-.99-.424a1.356 1.356 0 0 1-.424-.99v-2.662a.687.687 0 0 1 .707-.707.687.687 0 0 1 .707.707v2.662h12.252v-2.662a.687.687 0 0 1 .707-.707.687.687 0 0 1 .707.707v2.662c0 .377-.141.707-.424.99a1.356 1.356 0 0 1-.99.424H1.574z"}));
}

Download.displayName = "Download";

Download.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Download;

Download.default = Download;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/download.svg
// module id = 1265
// module chunks = 0